<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="orange"
    header-text-variant="light"
    centered
    size="xl"
    v-model="open"
    :title="title"
    :busy="loading"
    :hide-footer="true"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12" class="mt-4">
        <button
          :class="
            typeProducts == 'geral'
              ? 'btn-type-products-selected'
              : 'btn-type-products'
          "
          @click="selectType('geral')"
        >
          Geral
        </button>
        <button
          :class="
            typeProducts == 'fixadores'
              ? 'btn-type-products-selected'
              : 'btn-type-products'
          "
          @click="selectType('fixadores')"
        >
          Fixadores
        </button>
      </b-col>

      <b-col cols="12" class="mt-3">
        <label>Buscar produto</label>
      </b-col>
      <b-col cols="9">
        <input 
          type="text"
          class="form-control" 
          v-model="product" 
          @keyup.enter="search()"
          placeholder="Nome produto, cód. barras ou marca..."
        >
      </b-col>
      <b-col cols="">
        <b-button
          variant="success"
          @click="search()"
        >Pesquisar</b-button>
        <b-button
        class="ml-4"
          variant="warning"
          @click="clean()"
        >Limpar</b-button>
      </b-col>
      
      <b-col cols="12" class="mt-5">
        <b-table
          striped
          outlined
          hover
          responsive
          :fields="table.headers"
          :items="table.records"
          :busy="loading"
        >
        <template #cell(action)="data">
          <b-button 
            v-if="!productExist(data.item.id)"
            @click="insertProductService(data.item.id)"
            variant="success"
            data-toggle="tooltip" data-placement="top" title="Inserir produto no serviço"
          >
            <i class="fas fa-plus"></i>
          </b-button>
          <b-button 
            v-else
            @click="deleteProduct(data.item.id)"
            variant="danger"
            data-toggle="tooltip" data-placement="top" title="Remover produto do serviço"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>

        <template #cell(photo)="data">
          <img
            :src="linkFotos(data.item.origem) + data.item.photo"
            :alt="data.item.product"
            class="imgWidth"
          />
        </template>

        <template #cell(priceSalesFormat1)="data">
          <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
        </template>
        </b-table>
      </b-col>
      <div class="ml-3 mt-5" v-observe-visibility="visibilityChanged">Carregando mais itens..</div>
    </b-row>
    <b-row class="d-flex justify-content-end">
      <b-button
        class="mr-3"
        @click="closeModal()"
        variant="danger"
      >
      Fechar
    </b-button>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'modalAddProductsApp',
  mixins: [makeToast],
  emits: ['getProductSelect'],

  data() {
    return {
      loading: false,
      typeProducts: 'geral',
      item: [],
      product:'',
      title: '',
      idService: null,
      open: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
      },
      table:{
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
          key: 'action',
          label: 'Ação',
          },
          {
            key: 'photo',
            label: 'Imagem',
          },
          {
            key: 'product',
            label: 'Produto',
          },
          {
            key:'priceSalesFormat1',
            label: 'Preço'
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
          },
          {
            key: 'marca',
            label: 'Marca',
          },
        ],
        records:[]
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getSelectedProducts',
      'deleteProductService',
      'addProductService',
    ]),

    toggleOpen({ item = [], title = '' }) {
      this.open = !this.open;
      this.item = item.data_product_service;
      this.idService = item.id;
      this.title = title;
      this.clean();
    },
    selectType(type) {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.typeProducts = type;
      this.get();
    },
    productExist(id){
      if(this.item.length == 0) return
      const result = this.item.map((item) => {
        if(item.selected_product_id == id) return true;
      });
      return result.includes(true);
    },
    search() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.get();
    },
    clean() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.product = '';
      this.get();
    },
    get() {
      if (this.loading) return;

      this.loading = true;
      this.getSelectedProducts({
        userId: this.userTypeId(),
        productName: this.product,
        currentPage: this.pagination.currentPage,
        familyId: 0,
        typeProducts: this.typeProducts,
        startDate: '',
        endDate: '',
        status: '',
      })
      .then((response) => {
        const { perPage, total } = response.data.data || {};
        this.pagination.itemsPerPage = perPage || 15;
        this.pagination.total = total;
        this.table.records.push(...response.data.data.data);
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
        this.loading = false;
      });
    },
    deleteProduct(id) {
      let productId = ''
      let indexRemove = ''
      this.item.map((item, index) => {
        if(item.selected_product_id == id) {
          productId = item.id;
          indexRemove = index;
        }
      });

      this.$store.dispatch('startLoader');

      this.deleteProductService(productId)
        .then((resp) => {
          if(resp.data.data.registro_deletado && indexRemove !== '')
            this.item.splice(indexRemove, 1);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao excluir produto do serviço!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    closeModal(){
      this.open = !this.open;
      this.$emit('getProductSelect');
    },
    insertProductService(id) {
      let data = {
        shopkeeper_service_id: this.idService,
        selected_product_id: id,
        active: 1
      }
      this.$store.dispatch('startLoader');
      this.addProductService(data)
        .then((resp) => {
          if(resp.data.data.id)
            data.id = resp.data.data.id
            this.item.push(data);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao adicionar o produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    visibilityChanged(isVisible) {
      if (!isVisible || this.loading == true) return;
      const totalPage = this.pagination.total / this.pagination.itemsPerPage;
      if (this.pagination.currentPage >= Math.ceil(totalPage)) return;
      this.pagination.currentPage = this.pagination.currentPage + 1;
    },
  },
};
</script>

<style scoped>
.imgWidth {
  width: 50px;
}
.btn-type-products {
width: 45%;
border: 1px solid #ff7f00;
border-radius: 3px;
padding: 5px 10px;
color: #222;
background-color: transparent;
}
.btn-type-products-selected {
width: 45%;
border: 1px solid #ff7f00;
border-radius: 3px;
padding: 5px 10px;
color: #fff;
background-color: #ff7f00;
}
</style>
